import React, { useState } from "react"
import { Content, Right, SearchBlock } from "./style"
import LogoLight from "assets/images/mmbaza-logo-white.png"
import Logo from "components/Logo"
import ButtonComponent from "components/Button"
import { useHideModal, useShowModal } from "hooks"
import ContactUs from "components/Forms/ContactUs"
import { useLocation, useNavigate } from "react-router-dom"
import WithSearch from "components/Filters/WithSearch"
import { useDispatch, useSelector } from "react-redux"
import { setFilters } from "redux/modules/application/actions"
import LanguageSwitcher from "components/LanguageSwitcher"
import MobileNav from "./Mobile"
import { RadioSelect } from "components/LanguageSwitcher/RadioGroupSelection"
import { useTranslation } from "react-i18next"
import { classNames } from "utils/classNames"
import { GoogleLogout } from "react-google-login"
import { clearUserDatas } from "redux/modules/userDatas/actions"
import { HiOutlineUser } from "react-icons/hi"
import { CiSearch } from "react-icons/ci"
import AboutForModal from "views/About/AboutForModal"

const modalScreens = {
  contactUs: <ContactUs withAddress />,
  AboutUs: <AboutForModal />,
}

const Navbar = ({ isAuthPage = false }) => {
  const { showBlured } = useShowModal()
  const { hideModal } = useHideModal()
  const { t } = useTranslation()
  const navigate = useNavigate()
  const userData = JSON.parse(localStorage.getItem("user"))
  const { filters } = useSelector((state) => state.appReducer)
  const { token } = useSelector((state) => state.userDatasReducer)
  const dispatch = useDispatch()
  const [openSearch, setOpenSearch] = useState(false)

  const location = useLocation()

  const navBtns = [
    {
      id: "Асосий",
      title: t("primary"),
      href: "/",
      show: true,
    },
    {
      id: "Сайт ҳақида",
      title: t("about"),
      href: "/about-us",
      show: true,
      type: "AboutUs",
      screenWidth: "900px",
    },
    {
      id: "Боғланиш",
      title: t("contact-us"),
      href: "/contact-us",
      show: true,
      type: "contactUs",
    },
    {
      id: "language",
      component: <LanguageSwitcher />,
      language: true,
      show: true,
    },
    {
      id: "Рўйхатдан ўтиш",
      title: t("sign-up"),
      href: "/auth",
      show: !token ? true : false,
      border: true,
    },
    {
      id: "1a2sd1a2sd1asd2as1d2as1d",
      icon: HiOutlineUser,
      title: `${userData?.givenName} ${userData?.familyName}`,
      href: "/",
      show: token ? true : false,
      bordered: true,
      dropdown: true,
    },
  ]

  // const checkPath = () => {
  //   if (pathname !== "/work" || pathname !== "/") navigate("/works")
  // }
  const filterOnHome = (type, id) => {
    dispatch(setFilters({ ...filters, [type]: id }))
    // checkPath()
  }

  const navTabsHandler = (item) => {
    if (item.type) {
      showBlured({
        title: item?.title,
        maxWidth: item?.screenWidth ?? "550px",
        maxHeight: "70vh",
        withHeader: true,
        rounded: true,
        button: false,
        background: "rgba(57,57,57,.8)",
        headerColor: "rgba(57,57,57,.8)",
        body: () => (
          <div
            className={classNames(
              item?.type === "contactUs" ? "px-10 py-10 flex-auto" : ""
            )}
          >
            {modalScreens[item?.type]}
          </div>
        ),
      })
    } else {
      localStorage.setItem("pathname", location.pathname)
      navigate(item?.href)
    }
  }

  const handleNavItem = (path, button) => {
    if (button) {
      switch (button) {
        case "lang":
          return showBlured({
            title: "",
            maxWidth: "480px",
            height: "571px",
            withHeader: false,
            rounded: false,
            body: () => (
              <RadioSelect closeModal={hideModal} handler={handleNavItem} />
            ),
          })
        case "contactUs":
          return showBlured({
            title: "Биз билан боғланиш",
            maxWidth: "480px",
            height: "571px",
            withHeader: true,
            rounded: "8px",
            body: () => <ContactUs closeModal={hideModal} />,
          })
        default:
          return
      }
    }
    if (path) {
      hideModal()
      navigate(path)
    }
  }

  const logout = () => {
    dispatch(clearUserDatas())
    navigate("/")
  }


  return (
    <Content className="px-4 md:px-6 lg:px-10 relative z-[3000] font-[Roboto]">
      <div className="w-full flex justify-between items-center h-full mx-auto max-w-[1920px]">
        <div>
          <Logo imgSrc={LogoLight} />
        </div>

        {location?.pathname === "/" ? (
          <div
            // className={classNames(
            //   isAuthPage
            //     ? "hidden"
            //     : "hidden xl:block xl:max-w-2xl max-w-[620px] ml-auto h-10 pr-[18px]"
            // )}
            className="max-[1150px]:hidden block xl:max-w-2xl max-w-[620px] ml-auto h-10 pr-[18px]"
          >
            <div className="flex items-center justify-end">
              <SearchBlock open={openSearch}>
                <WithSearch
                  handleSearch={filterOnHome}
                  setOpenSearch={setOpenSearch}
                  openSearch={openSearch}
                  smaller
                />
              </SearchBlock>
              {!openSearch && (
                <div className="flex items-center justify-end h-full">
                  <button
                    className="flex items-center justify-center bg-transparent"
                    onClick={() => setOpenSearch(true)}
                  >
                    <CiSearch size={24} />
                  </button>
                </div>
              )}
            </div>
          </div>
        ) : null}

        <Right className="gap-2">
          <div className="items-center justify-end gap-6 flex">
            {isAuthPage ? (
              <>
                {/* <ButtonComponent
                width="151px"
                height="40px"
                padding="12px 12px"
                background="transparent"
                color="white"
                text={t("Рўйхатдан ўтиш")}
                onClick={() => navigate("/auth")}
                className="hover:text-[color:var(--custom-primary)]"
              /> */}
                {t("sign-up")}
              </>
            ) : (
              <>
                {navBtns.map((button) =>
                  button?.bordered && button.show ? (
                    <GoogleLogout
                      key={button.id}
                      render={(renderProps) => (
                        <>
                          {button?.language ? (
                            <div>{button?.component}</div>
                          ) : (
                            <ButtonComponent
                              dropdown={button?.dropdown}
                              height="40px"
                              padding="12px 12px"
                              background="transparent"
                              color="white"
                              icon={button.icon}
                              text={button?.title}
                              onClick={renderProps.onClick}
                              disabled={renderProps.disabled}
                              className={classNames(
                                button?.border ? "rounded-[43px]" : "",
                                button.href === location.pathname
                                  ? "border-b-[1px]"
                                  : "",
                                "border border-white rounded-md px-4 hover:text-[color:var(--custom-primary)]"
                              )}
                            />
                          )}
                        </>
                      )}
                      clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
                      buttonText="Logout"
                      onLogoutSuccess={logout}
                    />
                  ) : button.show ? (
                    <div
                      key={button.id}
                      className={button?.border ? "" : "lg:inline hidden"}
                    >
                      {button?.language ? (
                        <>{button?.component}</>
                      ) : (
                        <ButtonComponent
                          // width="151px"
                          height="40px"
                          padding="12px 15px"
                          background="transparent"
                          color="white"
                          text={button?.title}
                          onClick={() => navTabsHandler(button)}
                          className={classNames(
                            button?.bordered
                              ? "border border-white rounded-md px-4"
                              : "",
                            button.href === location.pathname
                              ? "border-b-[1px]"
                              : "",
                            button?.border &&
                              "border border-white rounded-[43px]",
                            "hover:text-[color:var(--custom-primary)]"
                          )}
                        />
                      )}
                    </div>
                  ) : null
                )}
              </>
            )}
          </div>
          <div className="inline-block lg:hidden">
            <MobileNav
              // openMobileMenu={openMobileMenu}
              handleNavItem={handleNavItem}
            />
          </div>
        </Right>
      </div>
    </Content>
  )
}

export default Navbar
